<template>
  <div class="acc-questionnaire-list">
    <div class="opreationBox clearfix">
      <div class="fl" style="width: calc(100% - 200px);">
        <el-form :inline="true" class="demo-form-inline" label-width="100px">
          <el-form-item label="用户名称">
            <el-input placeholder="请输入" clearable v-model="queryParams.PanelName" />
          </el-form-item>
          <el-form-item label="完成状态" label-width="100px">
            <el-select
              v-model="queryParams.FinishState"
              placeholder="请选择完成状态"
              @change="handleCurrentChange(1)"
            >
              <el-option
                v-for="item in FinishStateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              end-placeholder="结束日期"
              start-placeholder="开始日期"
              @change="changeDateTime"
            />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button type="danger" plain @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="fl" style="width: 200px;">
        <el-button type="primary" @click="downloadQuestionnaire('会员答卷情况月度明细表')">会员答卷情况月度明细表</el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table v-loading="loading" :height="tableH" :data="dataList" border style="width: 100%">
        <el-table-column header-align="center" align="center" prop="user" label="会员微信名">
          <template slot-scope="{ row }">
            <span v-if="row.user">{{ row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="问卷名称">
          <template slot-scope="scope">
            <span>{{ scope.row.questionnaireName }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="完成状态">
          <template slot-scope="scope">
            <template v-for="(item,index) in FinishStateList">
              <span :key="index" :style="{color:item.color}" v-if="item.value == scope.row.finishState">
                {{ item.label }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="createTime" label="开始时间" width="180" />
        <el-table-column header-align="center" align="center" prop="finishTime" label="完成时间" width="180" />
<!--        <el-table-column header-align="center" align="center" prop="receivePrice" label="理论金额" />-->
<!--        <el-table-column header-align="center" align="center" prop="actualPrice" label="实收金额" />-->
        <el-table-column header-align="center" align="center" prop="actualPrice" label="会员酬金" />
        <el-table-column header-align="center" align="center" prop="enterpriseName" label="所属战略合伙人姓名" />
        <el-table-column header-align="center" align="center" prop="enterpriseManagerPhone" label="所属战略合伙人手机号" />
        <el-table-column header-align="center" align="center" prop="parentName" label="所属二级合伙人姓名" />
        <el-table-column header-align="center" align="center" prop="parentPhone" label="所属二级合伙人手机号" />
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="queryParams.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
    <downloadDialog ref="downloadDialog" />
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import {SetTableH} from "../../../utils/utils"
  import { getAgentQuesList as getList, managerpartnerchildrenalldetailexport, managerpartnerallchildrenalldetailexport } from 'api/request'
  import downloadDialog from "@/components/downloadDialog"
  export default {
    name: 'accQuestionnaireList',
    components: {
      downloadDialog
    },
    data() {
      return {
        queryParams: {
          PageIndex: 1,
          PageSize: 10,
          PanelName: '',
          StartTime: '',
          EndTime: '',
          FinishState: -1,
          PanelId: sessionStorage.getItem('uId')
        },
        total: 0,
        tableH: '250',
        loading: false,
        dataList: [],
        dateTime: [],
        FinishStateList: [
          {
            value: -1,
            label: '全部',
            color: ''
          },
          {
            value: 0,
            label: '未完成',
            color: ''
          },
          {
            value: 1,
            label: '被甄别',
            color: ''
          },
          {
            value: 2,
            label: '完成',
            color: ''
          },
          {
            value: 3,
            label: '完成但名额超出',
            color: ''
          }
        ],
        moment: moment
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
    methods: {
      async getList() {
        this.loading = true
        let data = await getList(this.queryParams)
        if (data) {
          this.dataList = data.rows
          this.total = data.total
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.queryParams.PageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.queryParams.PageIndex = val
        this.getList()
      },
      handleQuery() {
        this.queryParams.PageIndex = 1
        this.getList()
      },
      changeDateTime(val) {
        this.queryParams.StartTime = val ?  val[0] : undefined
        this.queryParams.EndTime = val ?  val[1] : undefined
      },
      reset() {
        this.dateTime = []
        Object.assign(this.$data.queryParams, this.$options.data().queryParams)
        this.handleQuery()
      },
      downloadQuestionnaire(title) {
        const enterpriseId = sessionStorage.getItem('enterpriseId')
        const uId = sessionStorage.getItem('uId')
        const url = enterpriseId && Number(enterpriseId) > 0 ? managerpartnerallchildrenalldetailexport : managerpartnerchildrenalldetailexport
        const downloadParams = enterpriseId && Number(enterpriseId) > 0 ? { panelId: uId, enterpriseId: enterpriseId, finishState: -1 } : { panelId: uId, finishState: -1 }
        const apiQueryStr = Object.keys(downloadParams).map(v => `&${v}=${downloadParams[v]}`).join('')
        this.$refs.downloadDialog.show({ api: url, apiQueryStr: apiQueryStr, title })
      }
    }
  }
</script>

<style scoped lang="scss">
  .acc-questionnaire-list{
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
  }
</style>
